import { Link } from "react-router-dom";
import { Crown, Gem, ArrowRight } from "lucide-react";

export const AppTunnels = () => (
  <section className="relative py-16 sm:py-20 px-5 sm:px-8 overflow-hidden" data-testid="app-tunnels">
    <div aria-hidden="true" className="pointer-events-none absolute inset-0">
      <div className="absolute top-0 left-1/4 w-[380px] h-[380px] rounded-full bg-fuchsia-600/8 blur-[120px]" />
      <div className="absolute bottom-0 right-1/4 w-[340px] h-[340px] rounded-full bg-[#FFB800]/8 blur-[110px]" />
    </div>
    <div className="relative max-w-5xl mx-auto">
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-teal-300 text-center">Two Doors Down</p>
      <h2 className="mt-2 font-display text-2xl sm:text-3xl font-bold text-white text-center">Enter the Experience</h2>
      <div className="mt-8 grid sm:grid-cols-2 gap-5">
        <Link to="/medusa" className="group relative bg-charcoal border border-fuchsia-500/30 hover:border-fuchsia-400/70 rounded-2xl p-7 transition-all duration-300 hover:shadow-[0_0_40px_rgba(236,72,153,0.2)]" data-testid="tunnel-medusa">
          <Crown size={26} className="text-fuchsia-400 mb-4" />
          <h3 className="font-display text-xl font-bold text-white">The Medusa Room</h3>
          <p className="mt-2 text-sm text-ice/55 leading-relaxed">The interactive studio: mix live stems, cut a vocal in the Snake Pit, play Piano Scales for real prizes, and chase the daily Petrified Beat.</p>
          <span className="mt-4 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-fuchsia-300 group-hover:gap-3.5 transition-all">
            Enter the Room <ArrowRight size={14} />
          </span>
        </Link>
        <Link to="/vip-vault" className="group relative bg-charcoal border border-[#FFB800]/30 hover:border-[#FFB800]/70 rounded-2xl p-7 transition-all duration-300 hover:shadow-[0_0_40px_rgba(255,184,0,0.15)]" data-testid="tunnel-vault">
          <Gem size={26} className="text-[#FFB800] mb-4" />
          <h3 className="font-display text-xl font-bold text-white">The VIP Vault</h3>
          <p className="mt-2 text-sm text-ice/55 leading-relaxed">The members-only chamber: crack the Crystal Grid and unlock unreleased stems, project files, and early-access drops.</p>
          <span className="mt-4 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-[#FFB800] group-hover:gap-3.5 transition-all">
            Approach the Vault <ArrowRight size={14} />
          </span>
        </Link>
      </div>
    </div>
  </section>
);
